import { FC } from 'react';
import { IRecurrenceMapMetric } from '../../../../models/injury';
import { ChartEmptyState } from './_shared/ChartEmptyState';
import { DistributionBars } from '../../../../shared/charts/DistributionBars';
import { DistributionSlice } from '../../../../shared/charts/chart.types';
import { getPaletteColor } from './_shared/chartPalette';

interface Props {
  data: IRecurrenceMapMetric | null;
  period?: string;
  height?: number;
}

export const RecurrenceMapChart: FC<Props> = ({ data }) => {
  if (!data || !data.zones || data.zones.length === 0) {
    return <ChartEmptyState />;
  }

  // Percentuale = quota di recidive sul totale infortuni DELLA zona (non sul
  // totale generale), come il tooltip storico "recidive / totali".
  const slices: DistributionSlice[] = data.zones.map((zone, index) => ({
    id: zone.zone,
    label: zone.zone,
    value: zone.recurrenceCount,
    percent: zone.totalCount > 0 ? Math.round((zone.recurrenceCount / zone.totalCount) * 100) : null,
    color: getPaletteColor(index),
  }));

  return (
    <DistributionBars
      data={slices}
      labelMode="value-percent"
      valueFormatter={(v) => `${v}`}
      tooltipLabel="Recidive"
    />
  );
};
